module.exports = __webpack_public_path__ + "static/media/clock.477339ed.svg";